var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._b({staticClass:"background-border-gray overflow-hidden position-relative",class:_vm.computedClasses,style:(_vm.styles)},'div',_vm.$attrs,false),[(_vm.text)?_c('span',{staticClass:"opacity-0",attrs:{"classes":_vm.textClasses}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }